module.exports = __webpack_public_path__ + "static/media/main-loader.efbe8f77.gif";